import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ContactCardList } from './contact-card-list';
import { ContactCardData, ContactCardElement } from '../plugins/with-contact-cards';

interface ToolbarContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  getContactCards: () => ContactCardData[];
  setShowContactCardDialog: (open: boolean) => void;
  setSelectedContactCard: (card: ContactCardElement | null) => void;
  handleContactCardInsert: (contact: ContactCardData) => void;
}

/**
 * Combined dialog component for the toolbar that manages both the contact list
 * and the create/edit dialog states.
 */
export function ToolbarContactDialog({
  open,
  onOpenChange,
  getContactCards,
  setShowContactCardDialog,
  setSelectedContactCard,
  handleContactCardInsert
}: ToolbarContactDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Insert Contact Card</DialogTitle>
        </DialogHeader>
        <ContactCardList
          contacts={getContactCards()}
          onSelect={(contact) => {
            handleContactCardInsert(contact);
            onOpenChange(false);
          }}
          onCreate={() => {
            setSelectedContactCard(null);
            setShowContactCardDialog(true);
            onOpenChange(false);
          }}
          className="border rounded-md"
        />
      </DialogContent>
    </Dialog>
  );
}
